import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren
} from "@angular/core";
import {AbstractVisbosControl} from "../../forms/abstract-visbos-control";
import {FormArray, FormBuilder} from "@angular/forms";
import {AccordionPanelComponent} from "ngx-bootstrap";
import {IModel} from "../../../../../shared/view-model/imodel.interface";
import {appInjector} from "../../../../../index";


@Component({
  selector: 'vb-nested-items-list',
  templateUrl: './nested-items-list.component.html',
  styleUrls: ['./nested-items-list.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => NestedItemsListComponent)}]
})
export class NestedItemsListComponent<T extends IModel> extends AbstractVisbosControl<T, FormArray> implements AfterViewChecked {

  @ViewChildren(AccordionPanelComponent)
  accordionGroups: QueryList<AccordionPanelComponent>;

  @ContentChild(TemplateRef) template;

  private _itemList: T[] = [];

  @Input()
  set itemList(value: T[]) {
    this._itemList = JSON.parse(JSON.stringify(value)) || [];
  }

  get itemList(): T[] {
    return this._itemList || [];
  }

  numberOfNestedItems: number = 0;

  @Input()
  label: string;

  @Input()
  name: string = "";

  @Input()
  editable: boolean = true;

  @Input()
  deletable: boolean = true;

  @Input()
  required: boolean = false;

  @Input()
  openFirst: boolean = false;

  @Input()
  defaultIdentifier: string = "default";

  @Output()
  itemDeleteClicked: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  itemAddClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(fb: FormBuilder, cd: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  ngOnChanges(changes: SimpleChanges): void {

    super.ngOnChanges(changes);

    if (changes.itemList) {
      this.reset();
      if (this.itemList) {
        this.itemList.forEach(i => this.onAdd());
      }
    }

  }

  ngAfterViewChecked() {
    if (this.required && this.accordionGroups.length == 0) {
      this.onAdd();
    }
  }

  buildControlContent(): FormArray {
    return NestedItemsListComponent.initControl(this.fb);
  }

  public static initControl(fb?: FormBuilder): FormArray {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.array([]);
  }

  onAdd(openLast: boolean = true) {
    this.itemAddClicked.emit();
    this.itemList.push(null);
    this.cd.detectChanges();
    this.numberOfNestedItems++;
    if (openLast) {
      if (this.accordionGroups && this.accordionGroups.length > 0) {
        this.accordionGroups.last.isOpen = true;
      }

    }
    this.cd.detectChanges();
  }

  onDelete(index: number, event?: Event) {
    if (event) {
      event.preventDefault(); // Prevent edit event from accordion
    }
    this.itemList.splice(index);
    this.itemDeleteClicked.emit(index);
    this.cd.detectChanges();
    this.numberOfNestedItems--;
    this.cd.detectChanges();
  }

  reset(fullReset: boolean = false) {
    this.control.controls = [];
    super.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/dialogs/nested-items-list/nested-items-list.component.ts